import { FormArray, FormControl } from '@angular/forms';

// Utility function to add/remove items from a FormArray as necessary to match target length
export function setFormArrayLength<T>(
  targetLength: number,
  formArray: FormArray<FormControl<T>>,
  addItemCallback: () => FormControl<T>,
): void {
  while (targetLength > formArray.length) {
    formArray.push(addItemCallback());
  }
  while (targetLength < formArray.length) {
    formArray.removeAt(formArray.length - 1);
  }
}
